export default __webpack_public_path__ + "static/media/noImageForInspection.5a432d6f.svg";